import { combineReducers } from 'redux';
import { billing } from './stores/billing/billing-reducer';
import { dashboard } from './stores/dashboard/reducer';
import { tempConnections } from './stores/temp-connections/temp-connections-reducer';
import { config } from './stores/config/config-reducer';
import { route } from './stores/route/route-reducer';
import { tags } from './stores/tags/tags-reducer';
import { user } from './stores/user/user-reducer';

import { settings } from './stores/settings/settings-reducer';
import { publicNotifications } from './stores/settings/public/reducer';
import userManagement from './stores/settings/userManagement/reducer';

import { companyProfile } from './stores/company/company/company-reducer';
import { companyLocation } from './stores/company/location/location-reducer';
import { companyProduct } from './stores/company/product/product-reducer';

import { profile } from './stores/profile/company/profile-reducer';
import membershipsReducer from './stores/profile/memberships/reducer';
import { profileLocation } from './stores/profile/location/location-reducer';
import { profileProduct } from './stores/profile/product/product-reducer';
import { connections } from './stores/connections/connections-reducer';
import { connectionsStats } from './stores/connections-stats/connections-stats-reducer';
import { onboarding } from './stores/onboarding/onboarding-reducer';
import { integration } from './stores/integration/integration-reducer';
import contracting from './stores/contracting/contracting-reducer';
import { contractingDashboard } from './components/contracting-dashboard/__storeFiles__/reducer';
import { contractingReports } from './stores/contracting-reports/reducer';
import messaging from './components/messaging/messagingStore/messaging-reducer';
import notification from './stores/notification/reducer';
import { partnerFinder } from './stores/partner-finder/partnerFinder-reducer';
import { editFieldModal } from './stores/profile-edit-modal/profile-edit-modal-reducer';

import { copyPaste } from './stores/copy-paste/copy-paste-reducer';

import marketingMaterials from './stores/marketing-materials/reducer';

import newsfeed from './stores/newsfeed/reducer';
import newsfeedMetaData from './stores/newsfeed/metaData/metaData-reducer';
import { publicPost } from './stores/newsfeed/postPage/reducer';
import { globalErrors } from './stores/global-errors-display/global-errors-display-reducer';
import ui from './stores/ui/ui-reducer';
import { routerReducer } from 'react-router-redux';
import { workspace } from './components/workspace/store/reducer';
import { massmessaging } from './components/massmessaging/store/reducer';
import sidebarHelp from './components/sidebarHelp/reducer';
import assetsConsolidation from './components/assets-consolidation/__storeFiles__/reducer';
import partnerDetails from './components/partner-details/__store__/reducer';
import settingsReducer from './components/settings/__store__/reducer';
import dummyAcct from './components/contracting/dummy-account/__store-files__/reducers';
import walls from './components/wall/__store__/reducer';

const initialState = {
  text: '',
  open: false,
  onOk: null,
};

export function globalAlert(state = initialState, { type, payload }) {
  switch (type) {
    case 'open_global_alert':
      return {
        ...state,
        open: true,
        text: payload.text,
        onOk: payload.onOk,
      };
    case 'close_global_alert':
      return initialState;
    default:
      return state;
  }
}

export default combineReducers({
  ui,
  messaging,
  notification,
  billing,
  contracting,
  dashboard,
  tempConnections,
  editFieldModal,
  config,
  route,
  routing: routerReducer,
  tags,
  user,
  companyProfile,
  companyLocation,
  companyProduct,
  profile,
  membershipsReducer,
  profileLocation,
  profileProduct,
  connections,
  connectionsStats,
  onboarding,
  integration,
  partnerFinder,
  settings,
  copyPaste,
  marketingMaterials,
  contractingDashboard,
  contractingReports,
  newsfeed,
  newsfeedMetaData,
  publicPost,
  globalErrors,
  userManagement,
  publicNotifications,
  workspace,
  massmessaging,
  sidebarHelp,
  assetsConsolidation,
  partnerDetails,
  settingsReducer,
  dummyAcct,
  walls,
  globalAlert,
});



// WEBPACK FOOTER //
// ./src/app/reducers.js